// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3XP6k","content":"Consent_content__FWX0J","footer":"Consent_footer__19kC3"};